import React from 'react';
import WaitlistStats from '../../components/waitlist/WaitlistStats';
import FilterBar from '../../components/filters/FilterBar';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { useSettings } from '../../contexts/SettingsContext';
import { PAGE_INFO } from '../../constants';
import './Waitlist.css';

/**
 * Waitlist Page Component
 * Waitlist management and subscriber statistics
 */
const Waitlist = () => {
  const { period, setPeriod, status, setStatus } = useFilterPersistence({
    pageKey: 'waitlist'
  });
  const settings = useSettings();
  const compact = settings.compactMode;

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
      status={status}
      onStatusChange={setStatus}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.WAITLIST.title}
        description={PAGE_INFO.WAITLIST.description}
        filters={filters}
      >
        <div className="waitlist-content">
          <WaitlistStats period={period} compact={compact} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Waitlist;
